import { invoicesAdapter } from '../adapters/invoicesAdapter';
import { newOrdersAdapter } from '../adapters/newOrdersAdapter';
import { oldOrdersAdapter } from '../adapters/oldOrdersAdapter';
import { payOrdersAdapter } from '../adapters/payOrdersAdapter';
import {
    getERPPayOrders,
    getERPPurchaseOrders,
    getPayOrders,
    getPurchaseOrders,
} from '../api';

export const tabConfigs = {
    nuevas_ordenes: {
        label: 'Nuevas órdenes de servicio',
        type: 'table',
        columns: [
            { label: 'ORDEN', accessor: 'name' },
            { label: 'TIPO DE ORDEN', accessor: 'typeIdName' },
            { label: 'REFERENCIA', accessor: 'ref' },
            { label: 'FECHA DE CARGA', accessor: 'createDate' },
            { label: 'RESPONSABLE', accessor: 'responsible' },
            { label: 'ESTADO', accessor: 'state' },
            { label: 'MONTO', accessor: 'amount' },
            { label: 'CANCELAR', accessor: 'cancel', isAction: true },
        ],
        fetchFunction: getERPPurchaseOrders,
        requiresParam: true,
        adapter: newOrdersAdapter,
    },
    pagos: {
        label: 'Pagos',
        type: 'accordion',
        fetchFunction: getERPPayOrders,
        requiresParam: true,
        adapter: invoicesAdapter,
        columnsHeader: [
            { label: 'PAGO', accessor: 'name' },
            { label: 'REFERENCIA', accessor: 'ref' },
            { label: 'FECHA DE CREACION', accessor: 'createDate' },
            { label: 'FECHA DE PAGO', accessor: 'estimatedPaymentDate' },
            { label: 'RESPONSABLE', accessor: 'responsible' },
            { label: 'METODO DE PAGO', accessor: 'paymentMethod' },
            { label: 'ESTADO', accessor: 'state' },
            { label: 'MONTO', accessor: 'amount' },
        ],
        columnsBody: [
            { label: 'ORDEN DE COMPRA', accessor: 'name' },
            { label: 'FACTURA', accessor: 'invoiceName' },
            { label: 'REFERENCIA', accessor: 'invoiceRef' },
            { label: 'FECHA DE FACTURA', accessor: 'invoiceDate' },
            { label: 'ESTADO', accessor: 'state' },
            { label: 'MONTO', accessor: 'invoiceAmount' },
        ],
    },
    ordenes: {
        label: 'Histórico órdenes de servicio',
        type: 'table',
        columns: [
            { label: 'ORDEN', accessor: 'name' },
            { label: 'ORDEN DE PAGO', accessor: 'payOrder' },
            { label: 'TIPO DE ORDEN', accessor: 'typeIdName' },
            { label: 'REFERENCIA', accessor: 'ref' },
            { label: 'FECHA DE CARGA', accessor: 'createDate' },
            { label: 'FECHA DE ACTIVIDAD', accessor: 'activityDate' },
            { label: 'RESPONSABLE', accessor: 'responsible' },
            { label: 'ESTADO', accessor: 'state' },
            { label: 'MONTO', accessor: 'amount' },
            { label: 'CANCELAR', accessor: 'cancel', isAction: true },
        ],
        fetchFunction: getPurchaseOrders,
        requiresParam: false,
        adapter: oldOrdersAdapter,
    },
    ordenes_pagos: {
        label: 'Histórico órdenes de pago',
        type: 'accordion',
        fetchFunction: getPayOrders,
        requiresParam: false,
        adapter: payOrdersAdapter,
        columnsHeader: [
            { label: 'ORDEN DE PAGO', accessor: 'name' },
            { label: 'REFERENCIA', accessor: 'ref' },
            { label: 'FECHA DE CREACION', accessor: 'createDate' },
            { label: 'FECHA DE PAGO', accessor: 'estimatedPaymentDate' },
            { label: 'RESPONSABLE', accessor: 'responsible' },
            { label: 'METODO DE PAGO', accessor: 'paymentMethod' },
            { label: 'ESTADO', accessor: 'state' },
            { label: 'MONTO', accessor: 'amount' },
        ],
        columnsBody: [
            { label: 'ORDEN DE COMPRA', accessor: 'name' },
            { label: 'REFERENCIA', accessor: 'ref' },
            { label: 'FECHA DE CARGA', accessor: 'date' },
            { label: 'RESPONSABLE', accessor: 'responsible' },
            { label: 'ESTADO', accessor: 'state' },
            { label: 'MONTO', accessor: 'amount' },
        ],
    },
};

export default tabConfigs;
